/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
(function () {
    // Global variables
    let isRunning = false;
    let startTime = 0;
    let animationFrame = null;
    let isDragging = false;
    let currentFixer = null;
    let dragStartX = 0;
    let dragStartY = 0;
    let elementStartX = 0;
    let elementStartY = 0;
    let isFullscreen = false;
    let showControls = false;

    // DOM elements
    const pixelFixer = document.getElementById('pixelFixer');
    const fullscreenFixer = document.getElementById('fullscreenFixer');
    const fixerContainer = document.getElementById('fixerContainer');
    const startBtn = document.getElementById('startBtn');
    const stopBtn = document.getElementById('stopBtn');
    const fullscreenBtn = document.getElementById('fullscreenBtn');
    const fullscreenOverlay = document.getElementById('fullscreenOverlay');
    const fullscreenTimer = document.getElementById('fullscreenTimer');
    const timerDisplay = document.getElementById('timer');
    const statusDisplay = document.getElementById('status');
    const fullscreenStartBtn = document.getElementById('fullscreenStartBtn');
    const fullscreenStopBtn = document.getElementById('fullscreenStopBtn');
    const toggleControlsBtn = document.getElementById('toggleControlsBtn');


    // Canvas contexts
    const ctxNormal = pixelFixer.getContext('2d', { willReadFrequently: true });
    const ctxFullscreen = fullscreenFixer.getContext('2d', { willReadFrequently: true });

    let frames = 0;
    // Function to generate random pixels (JScreenFix style)
    function generateRandomPixels(canvas, ctx) {
        if (!isRunning) return;

        const width = canvas.width;
        const height = canvas.height;
        const imageData = ctx.createImageData(width, height);
        const data = imageData.data;

        // Fill each pixel with random RGB values
        for (let i = 0; i < data.length; i += 4) {
            data[i] = Math.floor(Math.random() * 256);     // Red
            data[i + 1] = Math.floor(Math.random() * 256); // Green
            data[i + 2] = Math.floor(Math.random() * 256); // Blue
            data[i + 3] = 255;                              // Alpha
        }

        ctx.putImageData(imageData, 0, 0);

        // Continue animation
        animationFrame = requestAnimationFrame(() => {
            generateRandomPixels(canvas, ctx);
        });

        // Frame counter for the timer
        frames++;
        if (frames % 60 === 0) {
            updateTimer();
        }
    }

    // Update timer
    function updateTimer() {
        const elapsed = Date.now() - startTime;
        const minutes = Math.floor(elapsed / 60000);
        const seconds = Math.floor((elapsed % 60000) / 1000);

        const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        timerDisplay.textContent = `Time: ${timeString}`;
        fullscreenTimer.textContent = `Time: ${timeString}`;
    }

    // Start repair
    function startRepair() {
        if (isRunning) return;

        isRunning = true;
        startTime = Date.now();
        frames = 0;
        statusDisplay.textContent = 'Status: Repair in progress...';
        statusDisplay.className = 'status status-running';

        if (isFullscreen) {
            generateRandomPixels(fullscreenFixer, ctxFullscreen);
        } else {
            generateRandomPixels(pixelFixer, ctxNormal);
        }
    }

    // Stop repair
    function stopRepair() {
        if (!isRunning) return;

        isRunning = false;
        cancelAnimationFrame(animationFrame);
        statusDisplay.textContent = 'Status: Stopped';
        statusDisplay.className = 'status status-idle';

        // Clear canvases
        ctxNormal.clearRect(0, 0, pixelFixer.width, pixelFixer.height);
        ctxFullscreen.clearRect(0, 0, fullscreenFixer.width, fullscreenFixer.height);
    }

    // Toggle fullscreen
    function toggleFullscreen() {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(err => {
                console.log(`Error entering fullscreen: ${err.message}`);
            });
        } else {
            document.exitFullscreen();
        }
    }

    // Show/hide controls in fullscreen mode
    function toggleControls() {
        showControls = !showControls;
        if (showControls) {
            // fullscreenOverlay.classList.add('show-controls');
            // document.documentElement.classList.add('show-controls');
            document.querySelector('.fullscreen-timer').style.opacity = 1;
            document.querySelector('.fullscreen-instructions').style.opacity = 1;
            document.querySelector('.fullscreen-controls').style.opacity = 1;
            console.log("show controls", showControls, document.documentElement);
        } else {
            // fullscreenOverlay.classList.remove('show-controls');
            // document.documentElement.classList.remove('show-controls');
            document.querySelector('.fullscreen-timer').style.opacity = 0;
            document.querySelector('.fullscreen-instructions').style.opacity = 0;
            document.querySelector('.fullscreen-controls').style.opacity = 0;
            console.log("hide controls", showControls, document.documentElement);
        }
    }

    // Event handler for fullscreen changes
    document.addEventListener('fullscreenchange', () => {
        const wasRunning = isRunning;
        if (wasRunning) {
            stopRepair();
        }

        isFullscreen = !!document.fullscreenElement;

        if (isFullscreen) {
            centerElementInContainer(fullscreenFixer, {
                width: window.innerWidth,
                height: window.innerHeight,
                left: 0,
                top: 0
            });
            fullscreenOverlay.style.display = 'block';
            showControls = true;
            document.documentElement.classList.add('show-controls');
        } else {
            fullscreenOverlay.style.display = 'none';
            centerElementInContainer(pixelFixer, fixerContainer.getBoundingClientRect());
        }

        if (wasRunning) {
            setTimeout(() => startRepair(), 100);
        }
    });

    // Function to center an element in a container
    function centerElementInContainer(element, containerRect) {
        const elementWidth = parseFloat(window.getComputedStyle(element).width);
        const elementHeight = parseFloat(window.getComputedStyle(element).height);

        const left = (containerRect.width - elementWidth) / 2;
        const top = (containerRect.height - elementHeight) / 2;

        element.style.left = `${left}px`;
        element.style.top = `${top}px`;
    }

    // Initialize drag with a more precise method
    function setupDrag(element) {
        element.addEventListener('mousedown', startDrag);
        element.addEventListener('touchstart', startDrag, { passive: false });
    }

    function startDrag(e) {
        e.preventDefault();
        isDragging = true;
        currentFixer = this;

        const rect = currentFixer.getBoundingClientRect();
        elementStartX = rect.left;
        elementStartY = rect.top;

        if (e.type === 'mousedown') {
            dragStartX = e.clientX;
            dragStartY = e.clientY;
        } else if (e.type === 'touchstart') {
            dragStartX = e.touches[0].clientX;
            dragStartY = e.touches[0].clientY;
        }

        currentFixer.style.cursor = 'grabbing';

        document.addEventListener('mousemove', dragElement);
        document.addEventListener('mouseup', stopDrag);
        document.addEventListener('touchmove', dragElement, { passive: false });
        document.addEventListener('touchend', stopDrag);
    }

    function dragElement(e) {
        if (!isDragging || !currentFixer) return;
        e.preventDefault();

        let currentX, currentY;
        if (e.type === 'mousemove') {
            currentX = e.clientX;
            currentY = e.clientY;
        } else if (e.type === 'touchmove') {
            currentX = e.touches[0].clientX;
            currentY = e.touches[0].clientY;
        }

        const deltaX = currentX - dragStartX;
        const deltaY = currentY - dragStartY;

        let newX = elementStartX + deltaX;
        let newY = elementStartY + deltaY;

        let containerRect;
        if (isFullscreen) {
            containerRect = {
                left: 0,
                top: 0,
                right: window.innerWidth,
                bottom: window.innerHeight,
                width: window.innerWidth,
                height: window.innerHeight
            };
        } else {
            containerRect = fixerContainer.getBoundingClientRect();
        }

        const elementRect = currentFixer.getBoundingClientRect();
        const elementWidth = elementRect.width;
        const elementHeight = elementRect.height;

        newX = Math.max(containerRect.left, Math.min(newX, containerRect.right - elementWidth));
        newY = Math.max(containerRect.top, Math.min(newY, containerRect.bottom - elementHeight));

        currentFixer.style.left = `${newX - containerRect.left}px`;
        currentFixer.style.top = `${newY - containerRect.top}px`;
    }

    function stopDrag() {
        if (isDragging) {
            isDragging = false;
            if (currentFixer) {
                currentFixer.style.cursor = 'grab';
                currentFixer = null;
            }

            document.removeEventListener('mousemove', dragElement);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchmove', dragElement);
            document.removeEventListener('touchend', stopDrag);
        }
    }

    // Button event handlers
    startBtn.addEventListener('click', startRepair);
    stopBtn.addEventListener('click', stopRepair);
    fullscreenBtn.addEventListener('click', toggleFullscreen);
    fullscreenStartBtn.addEventListener('click', startRepair);
    fullscreenStopBtn.addEventListener('click', stopRepair);
    toggleControlsBtn.addEventListener('click', toggleControls);

    // Keyboard handling for fullscreen mode
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.fullscreenElement) {
            document.exitFullscreen();
        }
        if (e.key === ' ' && document.fullscreenElement) {
            e.preventDefault();
            toggleControls();
        }
        if (e.key === 's' && document.fullscreenElement) {
            e.preventDefault();
            if (isRunning) {
                stopRepair();
            } else {
                startRepair();
            }
        }
    });

    // Window resize handling
    window.addEventListener('resize', () => {
        if (document.fullscreenElement) {
            centerElementInContainer(fullscreenFixer, {
                width: window.innerWidth,
                height: window.innerHeight,
                left: 0,
                top: 0
            });
        } else {
            centerElementInContainer(pixelFixer, fixerContainer.getBoundingClientRect());
        }
    });

    // Initialization
    setupDrag(pixelFixer);
    setupDrag(fullscreenFixer);

    // Center elements on load
    window.addEventListener('load', () => {
        centerElementInContainer(pixelFixer, fixerContainer.getBoundingClientRect());
    });

    // Prevent right-click context menu on repair areas
    pixelFixer.addEventListener('contextmenu', (e) => e.preventDefault());
    fullscreenFixer.addEventListener('contextmenu', (e) => e.preventDefault());

    // Warning before leaving
    window.addEventListener('beforeunload', (e) => {
        if (isRunning) {
            e.preventDefault();
            e.returnValue = 'Pixel repair is in progress. Are you sure you want to leave?';
        }
    });

    // Check if browser supports fullscreen
    if (!(document.documentElement.requestFullscreen || document.documentElement.mozRequestFullScreen ||
        document.documentElement.webkitRequestFullscreen || document.documentElement.msRequestFullscreen)) {
        fullscreenBtn.disabled = true;
        fullscreenBtn.title = "Fullscreen not supported by this browser";
    }
})()
/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-dead-pixel block)");
/* eslint-enable no-console */
